import type { OfferItem } from '@/services/inventory-api.service';

function normalizeCategory(value: string | undefined): string {
  return (value ?? '').trim().toLowerCase();
}

function normalizeKeyPart(value: string | undefined): string {
  return (value ?? '').trim().toLowerCase().replace(/\s+/g, '_');
}

export function getPassQuantityKey(
  domainId: number,
  item: OfferItem,
  itemIndex: number
): string {
  const category = normalizeCategory(item.customer_type);
  if (item.pass_pk != null && category) {
    return `${String(domainId)}-pk-${String(item.pass_pk)}-ct-${category}`;
  }
  const title = normalizeKeyPart(item.title);
  const period = normalizeKeyPart(item.period_title);
  if (category && title) {
    return `${String(domainId)}-ct-${category}-ttl-${title}-prd-${period || 'na'}`;
  }
  return `${String(domainId)}-idx-${String(itemIndex)}`;
}

export function getPassQuantity(
  selectedQuantities: Record<string, number>,
  domainId: number,
  item: OfferItem,
  itemIndex: number
): number {
  const key = getPassQuantityKey(domainId, item, itemIndex);
  if (!key.includes('-idx-')) {
    return selectedQuantities[key] ?? 0;
  }
  const idxKey = `${String(domainId)}-idx-${String(itemIndex)}`;
  const legacyKey = `${String(domainId)}-${String(itemIndex)}`;
  return selectedQuantities[key] ?? selectedQuantities[idxKey] ?? selectedQuantities[legacyKey] ?? 0;
}
